
import {UIGamePopupController} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupController'
import {UIMGamePopupCardConfirmation} from './UIMGamePopupCardConfirmation'
import {UIMGamePopupSelectPlayerAndResourceCard} from './UIMGamePopupSelectPlayerAndResourceCard'
import {CardPopupInformation,
    SelectCardPopupUsingDevelopmentCardFormat, SelectCardPopupForPendingDistributionFormat, SelectCardPopupStealCardFromAnotherPlayerFormat,
    SelectCardToDiscardFormat, SelectCardsToGiveToAnotherPlayer, SelectPlayerAndResourceCardFormat,
} from '@colonist/game-card-types'
import {UIGamePopupCardConfirmation} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupCardConfirmation'
import {UIGamePopupInformationView} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupInformationView'
import {UIGamePopupSelectCards} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupSelectCards'
import {UIGamePopupSelectDevelopmentCardFromPlayer} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupSelectDevelopmentCardFromPlayer'
import {UIGamePopupSelectResourcesCardsFromPlayer} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupSelectResourcesCardsFromPlayer'
import {UIGamePopupSelectPlayerAndResourceCard} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupSelectPlayerAndResourceCard'
import {UIGamePopupSelectDice} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupSelectDice'
import {UIMGamePopupSelectCardToGiveToAnotherPlayer} from './UIMGamePopupSelectCardToGiveToAnotherPlayer'
import {UIMGamePopupDiscardCards} from './UIMGamePopupDiscardCards'
import {PopupInformation, SelectDiceFormat} from '@colonist/game-base-types'
import {UIGamePopupMechanicIntroductionForBeginners} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupMechanicIntroductionForBeginners'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import {UIMDeviceHandler} from '../../ui_html/UIMDeviceHandler'
import {TranslationObject} from '@colonist/i18n'

export class UIMGamePopupController extends UIGamePopupController {
    onEvent(data: any, eventType: GameStateEnums.UIGameEventEnums): void {
        super.onEvent(data, eventType)
        switch(eventType) {
            case GameStateEnums.UIGameEventEnums.FloatingNotification: this.showFloatingNotification(data)
                break
            default:
                break
        }
    }

    // eslint-disable-next-line class-methods-use-this
    private showFloatingNotification(message: TranslationObject): void {
        UIMDeviceHandler.showNotification(message)
    }

    protected createPopupCardConfirmationView(cardPopupInformationFormat: CardPopupInformation): UIGamePopupCardConfirmation {
        return new UIMGamePopupCardConfirmation(this.uiGameManager, cardPopupInformationFormat)
    }

    protected createPopupSelectPlayerAndResourceCard(popupImageAndDescription: UIGamePopupInformationView, selectionFormat: SelectPlayerAndResourceCardFormat): UIGamePopupSelectPlayerAndResourceCard {
        return new UIMGamePopupSelectPlayerAndResourceCard(this.uiGameManager, popupImageAndDescription, selectionFormat)
    }

    getViewForCardConfirmationPopup(cardPopupInformationFormat: CardPopupInformation) {
        return new UIMGamePopupCardConfirmation(this.uiGameManager, cardPopupInformationFormat)
    }

    getPopupImageAndDescriptionForCardSelectorWindowForDevelopmentCard(popupInformation: PopupInformation) {
        return new UIGamePopupInformationView(this.uiGameManager, 0, 0, this.popupW, popupInformation)
    }

    getViewForCardSelectorWindowForDevelopmentCard(developmentCardSelectFormat: SelectCardPopupUsingDevelopmentCardFormat, popupImageAndDescription: UIGamePopupInformationView) {
        return new UIGamePopupSelectCards(this.uiGameManager, popupImageAndDescription, developmentCardSelectFormat.selectCardFormat)
    }

    getPopupImageAndDescriptionForCardSelectorWindowForPendingDistributions(popupInformation: PopupInformation) {
        return new UIGamePopupInformationView(this.uiGameManager, 0, 0, this.popupW, popupInformation)
    }

    getViewForCardSelectorWindowForPendingDistributions(pendingDistributionSelectFormat: SelectCardPopupForPendingDistributionFormat, popupImageAndDescription: UIGamePopupInformationView) {
        return new UIGamePopupSelectCards(this.uiGameManager, popupImageAndDescription, pendingDistributionSelectFormat.selectCardFormat)
    }

    getPopupImageAndDescriptionForCardSelectorWindowForGivingCardToAnotherPlayer(popupInformation: PopupInformation) {
        return new UIGamePopupInformationView(this.uiGameManager, 0, 0, this.popupW, popupInformation)
    }

    getViewForCardSelectorWindowForGivingCardToAnotherPlayer(selectCardFormat: SelectCardsToGiveToAnotherPlayer, popupImageAndDescription: UIGamePopupInformationView) {
        return new UIMGamePopupSelectCardToGiveToAnotherPlayer(this.uiGameManager, popupImageAndDescription, selectCardFormat)
    }

    getViewForCardDiscardPopup(discardCardFormat: SelectCardToDiscardFormat) {
        return new UIMGamePopupDiscardCards(this.uiGameManager, discardCardFormat, this.progressCardsState)
    }

    getPopupImageAndDescriptionForCardSelectorWindowToStealDevelopmentCard(popupInformation: PopupInformation) {
        return new UIGamePopupInformationView(this.uiGameManager, 0, 0, this.popupW, popupInformation)
    }

    getViewForCardSelectorWindowToStealDevelopmentCard(stealDevelopmentCardFormat: SelectCardPopupStealCardFromAnotherPlayerFormat, popupImageAndDescription: UIGamePopupInformationView) {
        return new UIGamePopupSelectDevelopmentCardFromPlayer(this.uiGameManager, popupImageAndDescription, stealDevelopmentCardFormat)
    }

    getPopupImageAndDescriptionForCardSelectorWindowToStealResourceCard(stealResourceCardFromAnotherPlayer: SelectCardPopupStealCardFromAnotherPlayerFormat, popupInformation: PopupInformation) {
        return new UIGamePopupInformationView(this.uiGameManager, 0, 0, this.popupW, popupInformation, undefined, stealResourceCardFromAnotherPlayer.overrideText)
    }

    getViewForCardSelectorWindowToStealResourceCard(stealResourceCardFromAnotherPlayer: SelectCardPopupStealCardFromAnotherPlayerFormat, popupImageAndDescription: UIGamePopupInformationView) {
        return new UIGamePopupSelectResourcesCardsFromPlayer(this.uiGameManager, popupImageAndDescription, stealResourceCardFromAnotherPlayer)
    }

    getPopupImageAndDescriptionForSelectPlayerUsingDevelopmentCard(popupInformation: PopupInformation) {
        return new UIGamePopupInformationView(this.uiGameManager, 0, 0, this.popupW, popupInformation)
    }

    getPopupImageAndDescriptionForSelectPlayerAndResourceCard(popupInformation: PopupInformation) {
        return new UIGamePopupInformationView(this.uiGameManager, 0, 0, this.popupW, popupInformation)
    }

    getViewForSelectPlayerAndResourceCard(selectionFormat: SelectPlayerAndResourceCardFormat, popupImageAndDescription: UIGamePopupInformationView) {
        return new UIMGamePopupSelectPlayerAndResourceCard(this.uiGameManager, popupImageAndDescription, selectionFormat)
    }

    protected getViewForMechanicIntroductionForBeginners(popupImageAndDescription: PopupInformation): UIGamePopupMechanicIntroductionForBeginners {
        return new UIGamePopupMechanicIntroductionForBeginners(this.uiGameManager, popupImageAndDescription)
    }

    getPopupImageAndDescriptionForSelectDice(popupInformation: PopupInformation) {
        return new UIGamePopupInformationView(this.uiGameManager, 0, 0, this.popupW, popupInformation)
    }

    getViewForSelectDice(selectDiceFormat: SelectDiceFormat, popupImageAndDescription: UIGamePopupInformationView) {
        return new UIGamePopupSelectDice(this.uiGameManager, popupImageAndDescription, selectDiceFormat)
    }
}
